import { useEffect, useRef, useCallback } from 'react';
import { getCableConsumer } from '../lib/cableConsumer';

export function useSessionMapChannel(sessionId, onMessage) {
  const subscriptionRef = useRef(null);
  const onMessageRef = useRef(onMessage);

  // Keep the callback ref updated
  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);

  useEffect(() => {
    if (!sessionId) return;

    const cable = getCableConsumer();

    subscriptionRef.current = cable.subscriptions.create(
      { channel: 'SessionMapChannel', session_id: sessionId },
      {
        received(data) {
          onMessageRef.current?.(data);
        },
        connected() {
          console.log('Connected to SessionMapChannel for session', sessionId);
        },
        disconnected() {
          console.log('Disconnected from SessionMapChannel');
        },
        rejected() {
          console.log('Subscription to SessionMapChannel was rejected');
        },
      }
    );

    return () => {
      if (subscriptionRef.current) {
        subscriptionRef.current.unsubscribe();
        subscriptionRef.current = null;
      }
    };
  }, [sessionId]);

  return subscriptionRef.current;
}
